import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
var useAmplitudeLog = function useAmplitudeLog() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    timesEvent = _useState2[0],
    setTimesEvent = _useState2[1];
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var amplitudeEvent = function amplitudeEvent(_ref) {
    var data = _ref.data,
      event = _ref.event,
      once = _ref.once;
    setTimesEvent(timesEvent + 1);

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (once && timesEvent > 0) return;
    logEvent({
      event: event,
      data: _objectSpread(_objectSpread({}, getSourceEventParams()), data)
    });
  };
  return {
    amplitudeEvent: amplitudeEvent
  };
};
export default useAmplitudeLog;